/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeLocation } from '../../models/employee-location';

export interface CreateEmployeeLocation$Json$Params {
  
    /**
     * The employee location to create
     */
    body?: EmployeeLocation
}

export function createEmployeeLocation$Json(http: HttpClient, rootUrl: string, params?: CreateEmployeeLocation$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeLocation>> {
  const rb = new RequestBuilder(rootUrl, createEmployeeLocation$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmployeeLocation>;
    })
  );
}

createEmployeeLocation$Json.PATH = '/api/EmployeeLocation';
